<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M14.936,24c-1.631,0-3.064-1.054-3.563-2.592l-7.766-1.636c-0.083-0.017-0.167-0.026-0.25-0.026
		c-0.319,0-0.621,0.125-0.849,0.354l-0.717,0.717c-0.142,0.142-0.33,0.22-0.53,0.22c-0.2,0-0.389-0.078-0.53-0.22
		c-0.142-0.142-0.22-0.33-0.22-0.531s0.078-0.389,0.22-0.53l0.717-0.717c0.511-0.511,1.189-0.793,1.909-0.793
		c0.188,0,0.376,0.02,0.56,0.059l7.292,1.537c0.205-1.876,1.798-3.341,3.728-3.341c0.042,0,0.084,0.001,0.127,0.003L18.26,2.117
		C18.537,0.871,19.622,0,20.899,0h1.853c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H20.9c-0.569,0-1.052,0.388-1.176,0.943
		l-3.203,14.413c1.308,0.612,2.165,1.937,2.165,3.394C18.686,22.318,17.004,24,14.936,24z M12.748,20.771
		c0.239,1.004,1.152,1.729,2.188,1.729c1.241,0,2.25-1.009,2.25-2.25S16.177,18,14.936,18s-2.25,1.009-2.25,2.25
		c0,0.082,0.006,0.17,0.02,0.273C12.734,20.602,12.748,20.686,12.748,20.771z"/>
	<path d="M9.115,17.573c-0.06,0-0.119-0.007-0.176-0.021l-5.951-1.423c-1.206-0.289-1.953-1.504-1.665-2.71L3.936,2.478
		C4.179,1.46,5.079,0.749,6.124,0.749c0.175,0,0.351,0.021,0.523,0.062l7.301,1.743c1.206,0.288,1.953,1.504,1.665,2.71l-1.923,8.03
		c-0.082,0.339-0.381,0.575-0.729,0.575c-0.059,0-0.118-0.007-0.175-0.021c-0.402-0.096-0.651-0.502-0.555-0.904l1.923-8.029
		c0.096-0.401-0.153-0.807-0.555-0.903l-1.463-0.349l-0.871,3.648c-0.081,0.339-0.381,0.576-0.729,0.576
		c-0.058,0-0.117-0.007-0.174-0.021L7.443,7.171C7.251,7.125,7.082,7.002,6.979,6.834c-0.105-0.17-0.137-0.372-0.09-0.567
		l0.871-3.648L6.3,2.271C6.24,2.256,6.182,2.25,6.125,2.25c-0.349,0-0.648,0.237-0.729,0.576L2.782,13.767
		c-0.096,0.402,0.153,0.807,0.555,0.903l5.952,1.423c0.402,0.096,0.651,0.501,0.555,0.904C9.763,17.336,9.464,17.573,9.115,17.573z
		 M9.98,6.234l0.697-2.918L9.218,2.968L8.521,5.886L9.98,6.234z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'warehouse-cart-package-ribbon-1',
    },
    name: {
      type: String,
      required: false,
      default: 'WarehouseCartPackageRibbon1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>